module.exports = __webpack_public_path__ + "static/img/pp_postnew.c717cacf.png";